<template lang="pug">
.row
  .col-md-6.col-sm-12
    .row
      .col
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th(colspan="2")
                  div {{ $t("ui.package") }}
            tbody
              tr
                td
                  span {{ $t("ui.id") }}
                td
                  .text-right
                    span {{ siteDetails.site[0].package_id }}
              tr
                td
                  .span {{ $t("ui.type") }}
                td
                  .text-right
                    span {{ siteDetails.site[0].package_type }}
              tr
                td
                  span {{ $t("ui.name") }}
                td
                  .text-right
                    span {{ siteDetails.site[0].package_desc_en }}
              tr
                td
                  span {{ $t("ui.price") }}
                td
                  .text-right
                    span(
                      :class="$n(siteDetails.site[0].package_price, 'currency')"
                      )
                      | {{ $n(siteDetails.site[0].package_price, 'currency') }}
              tr
                td
                  span {{ $t("ui.bo_right") }}
                td
                  .text-right
                    template(v-if="siteDetails.site[0].bo_right == 1")
                      span #[ {{ $t("ui.full_back_office_access_right") }}]
                    template(v-else-if="siteDetails.site[0].bo_right == 2")
                      span #[ {{ $t("ui.read_only_back_office") }}]
    .row
      .col
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th(colspan="2")
                  div {{ $t("ui.setting") }}
            tbody
              tr
                td
                  span {{ $t("ui.site_name") }}
                td
                  .text-right
                    span {{ siteDetails.site[0].site_name}}
  .col-md-6.col-sm-12
    .row
      .col
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-align-middle
            thead
              tr.thead-light
                th(colspan="2") {{ $t('ui.language') }}
              tr.thead-light
                th(width="70%") {{ $t('ui.name') }}
                th.text-center(width="30%") {{ $t('ui.default') }}
            tbody
              tr(v-for="item in siteDetails.language")
                td
                  span {{ $t("ui.langList." + item.language) }}
                td.text-center
                  span
                    i(:class="{'fas fa-check text-success': item.is_default, 'fas fa-times text-danger': !item.is_default  }")

    .row
      .col
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover
            thead.thead-light
              tr
                th
                  div {{ $t("ui.logo") }}
            tbody
              tr
                td
                  .text-center(v-if="siteDetails.site[0].logo != null")
                    img.logo-image(:src="siteDetails.site[0].logo_full_path")
                  .text-center(v-else)
                    span {{ siteDetails.site[0].logo_text }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  components: {
  },
  props: {
    siteId: {
      type: Number
    },
    siteDetails: {
      type: Object
    },
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
  }),
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    }
  },
  mounted: function() {},
  methods: {}
};
</script>